<ds-modal [modalInput]="modalConfig">
       @if(basicFunctionRemainingTrialDays > 0 ){
          <div class="modal-content-wrapper" modal-body>
              <p>{{ 'ess_trial_end_alert_text2' | translate }} 
              {{basicFunctionRemainingTrialDays ?? "0"}} {{'ess_trial_end_alert_text3' | translate }}
              </p>      
          </div>
       } 
       <div modal-footer>
              <ds-button [buttonInput]="addYourCardButton" (btnClick)="fnSubscribeNow()"></ds-button>
       </div>
</ds-modal>

